module.exports = "/fast-coin/img/coin/anim/out_2/out_2_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_008.png
// module id = 2314
// module chunks = 5